import { FunnelSimple } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuList,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";
import { typedObjectEntries } from "common/helpers/utils";

import { CAMPAIGNS_FILTERS } from "../../../constants";
import CampaignFilterOptions from "../CampaignFilterOptions";

import type { CampaignsSearchParams } from "../../../types";

export default function DesktopFilters({
  searchParams,
  setSearchParams,
}: {
  searchParams: CampaignsSearchParams;
  setSearchParams: (searchParams: CampaignsSearchParams) => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <FilterButton leftIcon={<FunnelSimple />} size="sm">
          Filter
        </FilterButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuList>
          {typedObjectEntries(CAMPAIGNS_FILTERS).map(
            <SearchParamsKey extends keyof CampaignsSearchParams>([
              key,
              { icon, label },
            ]: [
              SearchParamsKey,
              (typeof CAMPAIGNS_FILTERS)[SearchParamsKey],
            ]) => (
              <DropdownMenuSub key={key}>
                <DropdownMenuSubTrigger>
                  {icon}
                  {label}
                </DropdownMenuSubTrigger>
                <DropdownMenuPortal>
                  <DropdownMenuSubContent>
                    <DropdownMenuList>
                      <CampaignFilterOptions
                        searchParamsKey={key}
                        searchParams={searchParams}
                        setSearchParams={setSearchParams}
                      />
                    </DropdownMenuList>
                  </DropdownMenuSubContent>
                </DropdownMenuPortal>
              </DropdownMenuSub>
            ),
          )}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
